import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "relative h-screen w-full bg-gradient-to-br from-white via-purple-50 to-pink-50" }
const _hoisted_2 = { class: "h-full flex items-center justify-center" }
const _hoisted_3 = { class: "w-full sm:max-w-[50vw] px-4" }
const _hoisted_4 = { class: "flex justify-center mb-14 animate-slideFadeIn" }
const _hoisted_5 = { class: "flex gap-2" }

import DoneStep from "@/components/onboarding/DoneStep.vue"
import PhoneStep from "@/components/onboarding/PhoneStep.vue"
import SocialLinksStep from "@/components/onboarding/SocialLinksStep.vue"
import { computed, ref } from "vue"
import { useStore } from "vuex"



export default /*@__PURE__*/_defineComponent({
  __name: 'Onboarding',
  setup(__props) {

const store = useStore()

const step = ref(0)

const steps = [PhoneStep, SocialLinksStep, DoneStep]

const nextStep = () => {
    if (step.value < steps.length - 1) {
        step.value++
    }
}
const prevStep = () => {
    if (step.value > 0) {
        step.value--
    }
}
const onboardingData = computed(() => store.state.authOnboarding)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute top-6 left-6" }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "w-[85px] h-auto",
        alt: "Logo"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (_, i) => {
              return _createElementVNode("span", {
                key: i,
                class: _normalizeClass(["h-1.5 w-6 rounded-full transition-all", i <= step.value
                            ? 'bg-gradient-to-r from-purple-500 to-pink-400'
                            : 'bg-gray-200'])
              }, null, 2)
            }), 64))
          ])
        ]),
        (_openBlock(), _createBlock(_resolveDynamicComponent(steps[step.value]), {
          onNext: nextStep,
          onBack: prevStep,
          canGoBack: step.value > 0,
          class: "w-full animate-slideFadeIn"
        }, null, 40, ["canGoBack"]))
      ])
    ])
  ]))
}
}

})